/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './id-service-env-administration-schema-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './id-service-env-administration-schema-types';
const defaultOptions = {} as const;
export type ExchangeAccessTokenMutationVariables = Exact<{
  input: Types.ExchangeAccessTokenInput;
}>;


export type ExchangeAccessTokenMutation = { exchangeAccessToken: { accessToken: string, tokenType: string, expiresInSeconds: number } };

export type ChangeTenantAdminPasswordMutationVariables = Exact<{
  dto: Types.ChangeTenantAdminPasswordInput;
}>;


export type ChangeTenantAdminPasswordMutation = { changeTenantAdminPassword: { accessToken: string, tenantAdminName: string, tenantName: string } };

export type AuthenticateTenantAdminMutationVariables = Exact<{
  input: Types.AuthenticateTenantAdminInput;
}>;


export type AuthenticateTenantAdminMutation = { authenticateTenantAdmin: { accessToken: string, tenantAdminName: string, tenantAdminEmail: string, passwordChanged: boolean, tenantName: string, expiresInSeconds: number } };

export type EnvironmentOrchestrationAndManagedServiceDataQueryVariables = Exact<{
  id: any;
  condition?: Types.EnvironmentManagedServiceCondition | null | undefined;
  filter?: Types.EnvironmentManagedServiceFilter | null | undefined;
}>;


export type EnvironmentOrchestrationAndManagedServiceDataQuery = { orchestrationResult: { enabled: boolean, orchestrationState: Types.OrchestrationState } | null, environmentManagedServices: { nodes: Array<{ managedServiceId: string, managedServiceName: string | null, isCoreService: boolean | null, sortOrder: number | null, state: Types.EnvironmentServiceState, environmentId: any, tenantId: any, updatedAt: any, updatedBy: string }> } | null };

export type TenantAdminsWithDataQueryVariables = Exact<{
  filter?: Types.TenantAdminFilter | null | undefined;
  orderBy?: Array<Types.TenantAdminsOrderBy> | Types.TenantAdminsOrderBy | null | undefined;
  after?: any;
}>;


export type TenantAdminsWithDataQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, name: string | null, email: string | null, active: boolean | null, createdAt: any, createdBy: string | null, updatedAt: any, updatedBy: string | null }> } | null, nonFiltered: { totalCount: number } | null };

export type TenantAdministratorQueryVariables = Exact<{
  id: any;
}>;


export type TenantAdministratorQuery = { tenantAdmin: { id: any, tenantId: any, name: string | null, email: string | null, active: boolean | null, passwordChanged: boolean | null, passwordIsSet: boolean, createdAt: any, createdBy: string | null, updatedAt: any, updatedBy: string | null } | null };

export type DeleteTenantAdministratorMutationVariables = Exact<{
  input: Types.DeleteTenantAdminInput;
}>;


export type DeleteTenantAdministratorMutation = { deleteTenantAdmin: { tenantAdmin: { email: string | null } | null } | null };

export type ResetTenantAdministratorPasswordMutationVariables = Exact<{
  input: Types.ResetTenantAdminPasswordInput;
}>;


export type ResetTenantAdministratorPasswordMutation = { resetTenantAdminPassword: { tenantAdmin: { id: any, passwordIsSet: boolean } | null } | null };

export type CreateTenantAdministratorMutationVariables = Exact<{
  input: Types.CreateTenantAdminInput;
}>;


export type CreateTenantAdministratorMutation = { createTenantAdmin: { tenantAdmin: { active: boolean | null, createdAt: any, createdBy: string | null, email: string | null, id: any, passwordChanged: boolean | null, name: string | null, tenantId: any, updatedAt: any, updatedBy: string | null } | null } | null };

export type EnvironmentManagedServiceLogsQueryVariables = Exact<{
  condition?: Types.EnvironmentManagedServiceLogCondition | null | undefined;
  orderBy?: Array<Types.EnvironmentManagedServiceLogsOrderBy> | Types.EnvironmentManagedServiceLogsOrderBy | null | undefined;
}>;


export type EnvironmentManagedServiceLogsQuery = { environmentManagedServiceLogs: { nodes: Array<{ id: any, managedServiceId: string, messageType: string, messageBody: any, createdAt: any }> } | null };

export type ServiceAccountsQueryVariables = Exact<{
  condition?: Types.ServiceAccountCondition | null | undefined;
  filter?: Types.ServiceAccountFilter | null | undefined;
  orderBy?: Array<Types.ServiceAccountsOrderBy> | Types.ServiceAccountsOrderBy | null | undefined;
  after?: any;
}>;


export type ServiceAccountsQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, name: string, clientId: string, isProtected: boolean | null, createdAt: any, updatedAt: any }> } | null, nonFiltered: { totalCount: number } | null };

export type ExportServiceAccountsMutationVariables = Exact<{
  condition?: Types.ServiceAccountCondition | null | undefined;
  filter?: Types.ServiceAccountFilter | null | undefined;
}>;


export type ExportServiceAccountsMutation = { exportServiceAccounts: { version: string, exportedAt: any, serviceAccounts: Array<{ name: string, isProtected: boolean, permissions: Array<{ serviceId: string, name: string }> }> } };

export type ImportServiceAccountsMutationVariables = Exact<{
  input: Types.ImportServiceAccountsInput;
  environmentId: any;
  conflictResolution: Types.ConflictResolution;
}>;


export type ImportServiceAccountsMutation = { importServiceAccounts: { serviceAccounts: { created: Array<string>, updated: Array<string>, skipped: Array<string> } | null, errors: Array<{ entityType: string, entityName: string, errorCode: Types.ImportErrorCode, detail: string | null }> } };

export type ServiceAccountPermissionsQueryVariables = Exact<{
  id: any;
}>;


export type ServiceAccountPermissionsQuery = { serviceAccount: { name: string, serviceAccountPermissionAssignments: { totalCount: number, nodes: Array<{ id: any, permissionId: any }> } } | null };

export type GenerateServiceAccountSecretMutationVariables = Exact<{
  input: Types.GenerateServiceAccountSecretInput;
}>;


export type GenerateServiceAccountSecretMutation = { generateServiceAccountSecret: { clientSecret: string, serviceAccount: { tenantId: any, environmentId: any, clientId: string, name: string, updatedAt: any, updatedBy: string } | null } | null };

export type ServiceAccountQueryVariables = Exact<{
  id: any;
}>;


export type ServiceAccountQuery = { serviceAccount: { id: any, name: string, clientId: string, isSecretGenerated: boolean | null, isProtected: boolean | null, tenantId: any, environmentId: any, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string } | null };

export type UpdateServiceAccountMutationVariables = Exact<{
  input: Types.UpdateServiceAccountInput;
}>;


export type UpdateServiceAccountMutation = { updateServiceAccount: { clientMutationId: string | null, serviceAccount: { name: string, updatedAt: any, updatedBy: string } | null } | null };

export type DeleteServiceAccountMutationVariables = Exact<{
  input: Types.DeleteServiceAccountInput;
}>;


export type DeleteServiceAccountMutation = { deleteServiceAccount: { clientMutationId: string | null } | null };

export type SetServiceAccountProtectionMutationVariables = Exact<{
  input: Types.SetServiceAccountProtectionInput;
}>;


export type SetServiceAccountProtectionMutation = { setServiceAccountProtection: { id: any, isProtected: boolean | null } };

export type CreateServiceAccountMutationVariables = Exact<{
  input: Types.CreateServiceAccountInput;
}>;


export type CreateServiceAccountMutation = { createServiceAccount: { serviceAccount: { id: any, name: string } | null } | null };

export type IdServiceConfigDataQueryVariables = Exact<{
  environmentId: any;
}>;


export type IdServiceConfigDataQuery = { idServiceConfigurationByEnvironmentId: { id: any, managementSuperAdmins: Array<string | null> | null, allowedOrigins: Array<string | null> | null, accessTokenLifetime: number, cookieLifetime: number, serviceAccountTokenLifetime: number, workflowsEnabled: boolean, tenantId: any, environmentId: any, createdAt: any, updatedAt: any, updatedBy: string } | null };

export type TokenSigningKeyQueryVariables = Exact<{
  environmentId: any;
}>;


export type TokenSigningKeyQuery = { tokenSigningKey: { kid: string, nextRotationAt: any } };

export type UpdateIdServiceConfigMutationVariables = Exact<{
  input: Types.UpdateIdServiceConfigurationByEnvironmentIdInput;
}>;


export type UpdateIdServiceConfigMutation = { updateIdServiceConfigurationByEnvironmentId: { idServiceConfiguration: { managementSuperAdmins: Array<string | null> | null, allowedOrigins: Array<string | null> | null, accessTokenLifetime: number, cookieLifetime: number, serviceAccountTokenLifetime: number, workflowsEnabled: boolean } | null } | null };

export type RevokeAndRotateSigningKeyMutationVariables = Exact<{
  envId: any;
}>;


export type RevokeAndRotateSigningKeyMutation = { revokeAndRotateSigningKey: { tokenSigningKey: { kid: string, nextRotationAt: any } } };

export type IdpConfigurationsCountQueryVariables = Exact<{
  condition?: Types.IdpConfigurationCondition | null | undefined;
}>;


export type IdpConfigurationsCountQuery = { idpConfigurations: { totalCount: number, nodes: Array<{ enabled: boolean }> } | null };

export type IdpConfigDataQueryVariables = Exact<{
  condition?: Types.IdpConfigurationCondition | null | undefined;
}>;


export type IdpConfigDataQuery = { idpConfigurations: { nodes: Array<{ id: any, idpId: Types.IdentityProvider, enabled: boolean, displayName: string | null, useCustomBranding: boolean, sortOrder: number, idpImageUrl: string | null, status: string | null, environmentId: any }> } | null, scopes: { nodes: Array<{ idpId: Types.IdentityProvider, scopeName: string, required: boolean }> } | null };

export type CreateIdpConfigurationMutationVariables = Exact<{
  input: Types.CreateIdpConfigurationInput;
}>;


export type CreateIdpConfigurationMutation = { createIdpConfiguration: { clientMutationId: string | null } | null };

export type EnvironmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type EnvironmentsQuery = { environments: { totalCount: number } | null };

export type TenantAdminsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantAdminsQuery = { tenantAdmins: { totalCount: number } | null };

export type IdpConfigurationsQueryVariables = Exact<{
  idpConfigurationCondition?: Types.IdpConfigurationCondition | null | undefined;
  idpScopeFilter?: Types.IdpScopeFilter | null | undefined;
}>;


export type IdpConfigurationsQuery = { configurations: { nodes: Array<{ id: any, idpId: Types.IdentityProvider, useBuiltInIdp: boolean | null, discoveryDocumentUrl: string | null, clientId: string | null, clientSecretIsSet: boolean, scopes: Array<string | null>, enabled: boolean, useCustomBranding: boolean, displayName: string | null, idpImageUrl: string | null, sortOrder: number, logoutFromIdp: boolean, tenantId: any, environmentId: any, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string }> } | null, scopes: { nodes: Array<{ scopeName: string, required: boolean }> } | null };

export type UpdateIdpConfigurationMutationVariables = Exact<{
  input: Types.UpdateIdpConfigurationInput;
}>;


export type UpdateIdpConfigurationMutation = { updateIdpConfiguration: { idpConfiguration: { useBuiltInIdp: boolean | null, discoveryDocumentUrl: string | null, clientId: string | null, clientSecretIsSet: boolean, scopes: Array<string | null>, useCustomBranding: boolean, displayName: string | null, logoutFromIdp: boolean, enabled: boolean, updatedAt: any, updatedBy: string } | null } | null };

export type DeleteIdpConfigurationMutationVariables = Exact<{
  input: Types.DeleteIdpConfigurationInput;
}>;


export type DeleteIdpConfigurationMutation = { deleteIdpConfiguration: { clientMutationId: string | null } | null };

export type EnvironmentsWithDataQueryVariables = Exact<{
  filter?: Types.EnvironmentFilter | null | undefined;
  orderBy?: Array<Types.EnvironmentsOrderBy> | Types.EnvironmentsOrderBy | null | undefined;
  after?: any;
}>;


export type EnvironmentsWithDataQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, name: string, enabled: boolean, isDevelopment: boolean, createdAt: any, updatedAt: any, createdBy: string, updatedBy: string }> } | null, nonFiltered: { totalCount: number } | null };

export type EnvironmentQueryVariables = Exact<{
  id: any;
}>;


export type EnvironmentQuery = { environment: { id: any, tenantId: any, name: string, environmentTemplateName: string | null, enabled: boolean, isDevelopment: boolean, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string } | null };

export type DeleteEnvironmentMutationVariables = Exact<{
  input: Types.DeleteEnvironmentInput;
}>;


export type DeleteEnvironmentMutation = { deleteEnvironment: { clientMutationId: string | null } | null };

export type ChangeManagedServiceStateMutationVariables = Exact<{
  input: Types.ChangeServiceStateInput;
}>;


export type ChangeManagedServiceStateMutation = { changeManagedServiceState: { successfullySent: boolean } };

export type CreateEnvironmentMutationVariables = Exact<{
  input: Types.CreateEnvironmentInput;
}>;


export type CreateEnvironmentMutation = { createEnvironment: { environment: { id: any, tenantId: any, name: string, environmentTemplateId: string, enabled: boolean, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string } | null } | null };

export type EnvironmentTemplateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EnvironmentTemplateDataQuery = { environmentTemplates: { nodes: Array<{ id: string | null, name: string | null }> } | null };

export type EnvironmentManagedServicesQueryVariables = Exact<{
  condition: Types.EnvironmentManagedServiceCondition;
  filter: Types.EnvironmentManagedServiceFilter;
}>;


export type EnvironmentManagedServicesQuery = { environmentManagedServices: { nodes: Array<{ managedServiceId: string, managedServiceName: string | null, state: Types.EnvironmentServiceState }> } | null };

export type EnvironmentConnectionQueryVariables = Exact<{
  environmentId: any;
  serviceAccountCondition: Types.ServiceAccountCondition;
}>;


export type EnvironmentConnectionQuery = { environment: { isDevelopment: boolean } | null, serviceAccounts: { nodes: Array<{ id: any, clientId: string }> } | null };

export type EmailWhitelistPatternsQueryVariables = Exact<{
  condition?: Types.EmailWhitelistPatternCondition | null | undefined;
  filter?: Types.EmailWhitelistPatternFilter | null | undefined;
  orderBy?: Array<Types.EmailWhitelistPatternsOrderBy> | Types.EmailWhitelistPatternsOrderBy | null | undefined;
  after?: any;
}>;


export type EmailWhitelistPatternsQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, emailPattern: string, createdAt: any, updatedAt: any, createdBy: string, updatedBy: string }> } | null, nonFiltered: { totalCount: number } | null };

export type EmailWhitelistPatternQueryVariables = Exact<{
  id: any;
}>;


export type EmailWhitelistPatternQuery = { emailWhitelistPattern: { id: any, emailPattern: string, tenantId: any, environmentId: any, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string } | null, emailWhitelistPatternRoles: { nodes: Array<{ id: any, userRoleId: any, userRoleName: string | null, userRoleDescription: string | null }> } | null };

export type UpdateEmailWhitelistPatternMutationVariables = Exact<{
  input: Types.UpdateEmailWhitelistPatternInput;
}>;


export type UpdateEmailWhitelistPatternMutation = { updateEmailWhitelistPattern: { clientMutationId: string | null, emailWhitelistPattern: { emailPattern: string, updatedAt: any, updatedBy: string } | null } | null };

export type DeleteEmailWhitelistPatternMutationVariables = Exact<{
  input: Types.DeleteEmailWhitelistPatternInput;
}>;


export type DeleteEmailWhitelistPatternMutation = { deleteEmailWhitelistPattern: { clientMutationId: string | null } | null };

export type CreateEmailWhitelistPatternMutationVariables = Exact<{
  input: Types.CreateEmailWhitelistPatternInput;
}>;


export type CreateEmailWhitelistPatternMutation = { createEmailWhitelistPattern: { emailWhitelistPattern: { id: any, emailPattern: string, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string } | null } | null };


export const ExchangeAccessTokenDocument = gql`
    mutation ExchangeAccessToken($input: ExchangeAccessTokenInput!) {
  exchangeAccessToken(input: $input) {
    accessToken
    tokenType
    expiresInSeconds
  }
}
    `;
export type ExchangeAccessTokenMutationFn = Apollo.MutationFunction<ExchangeAccessTokenMutation, ExchangeAccessTokenMutationVariables>;

/**
 * __useExchangeAccessTokenMutation__
 *
 * To run a mutation, you first call `useExchangeAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeAccessTokenMutation, { data, loading, error }] = useExchangeAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExchangeAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeAccessTokenMutation, ExchangeAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeAccessTokenMutation, ExchangeAccessTokenMutationVariables>(ExchangeAccessTokenDocument, options);
      }
export type ExchangeAccessTokenMutationHookResult = ReturnType<typeof useExchangeAccessTokenMutation>;
export type ExchangeAccessTokenMutationResult = Apollo.MutationResult<ExchangeAccessTokenMutation>;
export type ExchangeAccessTokenMutationOptions = Apollo.BaseMutationOptions<ExchangeAccessTokenMutation, ExchangeAccessTokenMutationVariables>;
export const ChangeTenantAdminPasswordDocument = gql`
    mutation ChangeTenantAdminPassword($dto: ChangeTenantAdminPasswordInput!) {
  changeTenantAdminPassword(input: $dto) {
    accessToken
    tenantAdminName
    tenantName
  }
}
    `;
export type ChangeTenantAdminPasswordMutationFn = Apollo.MutationFunction<ChangeTenantAdminPasswordMutation, ChangeTenantAdminPasswordMutationVariables>;

/**
 * __useChangeTenantAdminPasswordMutation__
 *
 * To run a mutation, you first call `useChangeTenantAdminPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTenantAdminPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTenantAdminPasswordMutation, { data, loading, error }] = useChangeTenantAdminPasswordMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useChangeTenantAdminPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTenantAdminPasswordMutation, ChangeTenantAdminPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTenantAdminPasswordMutation, ChangeTenantAdminPasswordMutationVariables>(ChangeTenantAdminPasswordDocument, options);
      }
export type ChangeTenantAdminPasswordMutationHookResult = ReturnType<typeof useChangeTenantAdminPasswordMutation>;
export type ChangeTenantAdminPasswordMutationResult = Apollo.MutationResult<ChangeTenantAdminPasswordMutation>;
export type ChangeTenantAdminPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeTenantAdminPasswordMutation, ChangeTenantAdminPasswordMutationVariables>;
export const AuthenticateTenantAdminDocument = gql`
    mutation AuthenticateTenantAdmin($input: AuthenticateTenantAdminInput!) {
  authenticateTenantAdmin(input: $input) {
    accessToken
    tenantAdminName
    tenantAdminEmail
    passwordChanged
    tenantName
    expiresInSeconds
  }
}
    `;
export type AuthenticateTenantAdminMutationFn = Apollo.MutationFunction<AuthenticateTenantAdminMutation, AuthenticateTenantAdminMutationVariables>;

/**
 * __useAuthenticateTenantAdminMutation__
 *
 * To run a mutation, you first call `useAuthenticateTenantAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateTenantAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateTenantAdminMutation, { data, loading, error }] = useAuthenticateTenantAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateTenantAdminMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateTenantAdminMutation, AuthenticateTenantAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateTenantAdminMutation, AuthenticateTenantAdminMutationVariables>(AuthenticateTenantAdminDocument, options);
      }
export type AuthenticateTenantAdminMutationHookResult = ReturnType<typeof useAuthenticateTenantAdminMutation>;
export type AuthenticateTenantAdminMutationResult = Apollo.MutationResult<AuthenticateTenantAdminMutation>;
export type AuthenticateTenantAdminMutationOptions = Apollo.BaseMutationOptions<AuthenticateTenantAdminMutation, AuthenticateTenantAdminMutationVariables>;
export const EnvironmentOrchestrationAndManagedServiceDataDocument = gql`
    query EnvironmentOrchestrationAndManagedServiceData($id: UUID!, $condition: EnvironmentManagedServiceCondition, $filter: EnvironmentManagedServiceFilter) {
  orchestrationResult: environment(id: $id) {
    enabled
    orchestrationState
  }
  environmentManagedServices(condition: $condition, filter: $filter) {
    nodes {
      managedServiceId
      managedServiceName
      isCoreService
      sortOrder
      state
      environmentId
      tenantId
      updatedAt
      updatedBy
    }
  }
}
    `;

/**
 * __useEnvironmentOrchestrationAndManagedServiceDataQuery__
 *
 * To run a query within a React component, call `useEnvironmentOrchestrationAndManagedServiceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentOrchestrationAndManagedServiceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentOrchestrationAndManagedServiceDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEnvironmentOrchestrationAndManagedServiceDataQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentOrchestrationAndManagedServiceDataQuery, EnvironmentOrchestrationAndManagedServiceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentOrchestrationAndManagedServiceDataQuery, EnvironmentOrchestrationAndManagedServiceDataQueryVariables>(EnvironmentOrchestrationAndManagedServiceDataDocument, options);
      }
export function useEnvironmentOrchestrationAndManagedServiceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentOrchestrationAndManagedServiceDataQuery, EnvironmentOrchestrationAndManagedServiceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentOrchestrationAndManagedServiceDataQuery, EnvironmentOrchestrationAndManagedServiceDataQueryVariables>(EnvironmentOrchestrationAndManagedServiceDataDocument, options);
        }
export type EnvironmentOrchestrationAndManagedServiceDataQueryHookResult = ReturnType<typeof useEnvironmentOrchestrationAndManagedServiceDataQuery>;
export type EnvironmentOrchestrationAndManagedServiceDataLazyQueryHookResult = ReturnType<typeof useEnvironmentOrchestrationAndManagedServiceDataLazyQuery>;
export type EnvironmentOrchestrationAndManagedServiceDataQueryResult = Apollo.QueryResult<EnvironmentOrchestrationAndManagedServiceDataQuery, EnvironmentOrchestrationAndManagedServiceDataQueryVariables>;
export const TenantAdminsWithDataDocument = gql`
    query TenantAdminsWithData($filter: TenantAdminFilter, $orderBy: [TenantAdminsOrderBy!], $after: Cursor) {
  filtered: tenantAdmins(
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      name
      email
      active
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
  nonFiltered: tenantAdmins {
    totalCount
  }
}
    `;

/**
 * __useTenantAdminsWithDataQuery__
 *
 * To run a query within a React component, call `useTenantAdminsWithDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantAdminsWithDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantAdminsWithDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTenantAdminsWithDataQuery(baseOptions?: Apollo.QueryHookOptions<TenantAdminsWithDataQuery, TenantAdminsWithDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantAdminsWithDataQuery, TenantAdminsWithDataQueryVariables>(TenantAdminsWithDataDocument, options);
      }
export function useTenantAdminsWithDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantAdminsWithDataQuery, TenantAdminsWithDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantAdminsWithDataQuery, TenantAdminsWithDataQueryVariables>(TenantAdminsWithDataDocument, options);
        }
export type TenantAdminsWithDataQueryHookResult = ReturnType<typeof useTenantAdminsWithDataQuery>;
export type TenantAdminsWithDataLazyQueryHookResult = ReturnType<typeof useTenantAdminsWithDataLazyQuery>;
export type TenantAdminsWithDataQueryResult = Apollo.QueryResult<TenantAdminsWithDataQuery, TenantAdminsWithDataQueryVariables>;
export const TenantAdministratorDocument = gql`
    query TenantAdministrator($id: UUID!) {
  tenantAdmin(id: $id) {
    id
    tenantId
    name
    email
    active
    passwordChanged
    passwordIsSet
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useTenantAdministratorQuery__
 *
 * To run a query within a React component, call `useTenantAdministratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantAdministratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantAdministratorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTenantAdministratorQuery(baseOptions: Apollo.QueryHookOptions<TenantAdministratorQuery, TenantAdministratorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantAdministratorQuery, TenantAdministratorQueryVariables>(TenantAdministratorDocument, options);
      }
export function useTenantAdministratorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantAdministratorQuery, TenantAdministratorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantAdministratorQuery, TenantAdministratorQueryVariables>(TenantAdministratorDocument, options);
        }
export type TenantAdministratorQueryHookResult = ReturnType<typeof useTenantAdministratorQuery>;
export type TenantAdministratorLazyQueryHookResult = ReturnType<typeof useTenantAdministratorLazyQuery>;
export type TenantAdministratorQueryResult = Apollo.QueryResult<TenantAdministratorQuery, TenantAdministratorQueryVariables>;
export const DeleteTenantAdministratorDocument = gql`
    mutation DeleteTenantAdministrator($input: DeleteTenantAdminInput!) {
  deleteTenantAdmin(input: $input) {
    tenantAdmin {
      email
    }
  }
}
    `;
export type DeleteTenantAdministratorMutationFn = Apollo.MutationFunction<DeleteTenantAdministratorMutation, DeleteTenantAdministratorMutationVariables>;

/**
 * __useDeleteTenantAdministratorMutation__
 *
 * To run a mutation, you first call `useDeleteTenantAdministratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantAdministratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantAdministratorMutation, { data, loading, error }] = useDeleteTenantAdministratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTenantAdministratorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantAdministratorMutation, DeleteTenantAdministratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantAdministratorMutation, DeleteTenantAdministratorMutationVariables>(DeleteTenantAdministratorDocument, options);
      }
export type DeleteTenantAdministratorMutationHookResult = ReturnType<typeof useDeleteTenantAdministratorMutation>;
export type DeleteTenantAdministratorMutationResult = Apollo.MutationResult<DeleteTenantAdministratorMutation>;
export type DeleteTenantAdministratorMutationOptions = Apollo.BaseMutationOptions<DeleteTenantAdministratorMutation, DeleteTenantAdministratorMutationVariables>;
export const ResetTenantAdministratorPasswordDocument = gql`
    mutation ResetTenantAdministratorPassword($input: ResetTenantAdminPasswordInput!) {
  resetTenantAdminPassword(input: $input) {
    tenantAdmin {
      id
      passwordIsSet
    }
  }
}
    `;
export type ResetTenantAdministratorPasswordMutationFn = Apollo.MutationFunction<ResetTenantAdministratorPasswordMutation, ResetTenantAdministratorPasswordMutationVariables>;

/**
 * __useResetTenantAdministratorPasswordMutation__
 *
 * To run a mutation, you first call `useResetTenantAdministratorPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetTenantAdministratorPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetTenantAdministratorPasswordMutation, { data, loading, error }] = useResetTenantAdministratorPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetTenantAdministratorPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetTenantAdministratorPasswordMutation, ResetTenantAdministratorPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetTenantAdministratorPasswordMutation, ResetTenantAdministratorPasswordMutationVariables>(ResetTenantAdministratorPasswordDocument, options);
      }
export type ResetTenantAdministratorPasswordMutationHookResult = ReturnType<typeof useResetTenantAdministratorPasswordMutation>;
export type ResetTenantAdministratorPasswordMutationResult = Apollo.MutationResult<ResetTenantAdministratorPasswordMutation>;
export type ResetTenantAdministratorPasswordMutationOptions = Apollo.BaseMutationOptions<ResetTenantAdministratorPasswordMutation, ResetTenantAdministratorPasswordMutationVariables>;
export const CreateTenantAdministratorDocument = gql`
    mutation CreateTenantAdministrator($input: CreateTenantAdminInput!) {
  createTenantAdmin(input: $input) {
    tenantAdmin {
      active
      createdAt
      createdBy
      email
      id
      passwordChanged
      name
      tenantId
      updatedAt
      updatedBy
    }
  }
}
    `;
export type CreateTenantAdministratorMutationFn = Apollo.MutationFunction<CreateTenantAdministratorMutation, CreateTenantAdministratorMutationVariables>;

/**
 * __useCreateTenantAdministratorMutation__
 *
 * To run a mutation, you first call `useCreateTenantAdministratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantAdministratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantAdministratorMutation, { data, loading, error }] = useCreateTenantAdministratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTenantAdministratorMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantAdministratorMutation, CreateTenantAdministratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantAdministratorMutation, CreateTenantAdministratorMutationVariables>(CreateTenantAdministratorDocument, options);
      }
export type CreateTenantAdministratorMutationHookResult = ReturnType<typeof useCreateTenantAdministratorMutation>;
export type CreateTenantAdministratorMutationResult = Apollo.MutationResult<CreateTenantAdministratorMutation>;
export type CreateTenantAdministratorMutationOptions = Apollo.BaseMutationOptions<CreateTenantAdministratorMutation, CreateTenantAdministratorMutationVariables>;
export const EnvironmentManagedServiceLogsDocument = gql`
    query EnvironmentManagedServiceLogs($condition: EnvironmentManagedServiceLogCondition, $orderBy: [EnvironmentManagedServiceLogsOrderBy!]) {
  environmentManagedServiceLogs(condition: $condition, orderBy: $orderBy) {
    nodes {
      id
      managedServiceId
      messageType
      messageBody
      createdAt
    }
  }
}
    `;

/**
 * __useEnvironmentManagedServiceLogsQuery__
 *
 * To run a query within a React component, call `useEnvironmentManagedServiceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentManagedServiceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentManagedServiceLogsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useEnvironmentManagedServiceLogsQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentManagedServiceLogsQuery, EnvironmentManagedServiceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentManagedServiceLogsQuery, EnvironmentManagedServiceLogsQueryVariables>(EnvironmentManagedServiceLogsDocument, options);
      }
export function useEnvironmentManagedServiceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentManagedServiceLogsQuery, EnvironmentManagedServiceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentManagedServiceLogsQuery, EnvironmentManagedServiceLogsQueryVariables>(EnvironmentManagedServiceLogsDocument, options);
        }
export type EnvironmentManagedServiceLogsQueryHookResult = ReturnType<typeof useEnvironmentManagedServiceLogsQuery>;
export type EnvironmentManagedServiceLogsLazyQueryHookResult = ReturnType<typeof useEnvironmentManagedServiceLogsLazyQuery>;
export type EnvironmentManagedServiceLogsQueryResult = Apollo.QueryResult<EnvironmentManagedServiceLogsQuery, EnvironmentManagedServiceLogsQueryVariables>;
export const ServiceAccountsDocument = gql`
    query ServiceAccounts($condition: ServiceAccountCondition, $filter: ServiceAccountFilter, $orderBy: [ServiceAccountsOrderBy!], $after: Cursor) {
  filtered: serviceAccounts(
    orderBy: $orderBy
    condition: $condition
    filter: $filter
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      name
      clientId
      isProtected
      createdAt
      updatedAt
    }
  }
  nonFiltered: serviceAccounts(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useServiceAccountsQuery__
 *
 * To run a query within a React component, call `useServiceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAccountsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useServiceAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceAccountsQuery, ServiceAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceAccountsQuery, ServiceAccountsQueryVariables>(ServiceAccountsDocument, options);
      }
export function useServiceAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceAccountsQuery, ServiceAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceAccountsQuery, ServiceAccountsQueryVariables>(ServiceAccountsDocument, options);
        }
export type ServiceAccountsQueryHookResult = ReturnType<typeof useServiceAccountsQuery>;
export type ServiceAccountsLazyQueryHookResult = ReturnType<typeof useServiceAccountsLazyQuery>;
export type ServiceAccountsQueryResult = Apollo.QueryResult<ServiceAccountsQuery, ServiceAccountsQueryVariables>;
export const ExportServiceAccountsDocument = gql`
    mutation ExportServiceAccounts($condition: ServiceAccountCondition, $filter: ServiceAccountFilter) {
  exportServiceAccounts(condition: $condition, filter: $filter) {
    version
    exportedAt
    serviceAccounts {
      name
      isProtected
      permissions {
        serviceId
        name
      }
    }
  }
}
    `;
export type ExportServiceAccountsMutationFn = Apollo.MutationFunction<ExportServiceAccountsMutation, ExportServiceAccountsMutationVariables>;

/**
 * __useExportServiceAccountsMutation__
 *
 * To run a mutation, you first call `useExportServiceAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportServiceAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportServiceAccountsMutation, { data, loading, error }] = useExportServiceAccountsMutation({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportServiceAccountsMutation(baseOptions?: Apollo.MutationHookOptions<ExportServiceAccountsMutation, ExportServiceAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportServiceAccountsMutation, ExportServiceAccountsMutationVariables>(ExportServiceAccountsDocument, options);
      }
export type ExportServiceAccountsMutationHookResult = ReturnType<typeof useExportServiceAccountsMutation>;
export type ExportServiceAccountsMutationResult = Apollo.MutationResult<ExportServiceAccountsMutation>;
export type ExportServiceAccountsMutationOptions = Apollo.BaseMutationOptions<ExportServiceAccountsMutation, ExportServiceAccountsMutationVariables>;
export const ImportServiceAccountsDocument = gql`
    mutation ImportServiceAccounts($input: ImportServiceAccountsInput!, $environmentId: UUID!, $conflictResolution: ConflictResolution!) {
  importServiceAccounts(
    input: $input
    environmentId: $environmentId
    conflictResolution: $conflictResolution
  ) {
    serviceAccounts {
      created
      updated
      skipped
    }
    errors {
      entityType
      entityName
      errorCode
      detail
    }
  }
}
    `;
export type ImportServiceAccountsMutationFn = Apollo.MutationFunction<ImportServiceAccountsMutation, ImportServiceAccountsMutationVariables>;

/**
 * __useImportServiceAccountsMutation__
 *
 * To run a mutation, you first call `useImportServiceAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportServiceAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importServiceAccountsMutation, { data, loading, error }] = useImportServiceAccountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      environmentId: // value for 'environmentId'
 *      conflictResolution: // value for 'conflictResolution'
 *   },
 * });
 */
export function useImportServiceAccountsMutation(baseOptions?: Apollo.MutationHookOptions<ImportServiceAccountsMutation, ImportServiceAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportServiceAccountsMutation, ImportServiceAccountsMutationVariables>(ImportServiceAccountsDocument, options);
      }
export type ImportServiceAccountsMutationHookResult = ReturnType<typeof useImportServiceAccountsMutation>;
export type ImportServiceAccountsMutationResult = Apollo.MutationResult<ImportServiceAccountsMutation>;
export type ImportServiceAccountsMutationOptions = Apollo.BaseMutationOptions<ImportServiceAccountsMutation, ImportServiceAccountsMutationVariables>;
export const ServiceAccountPermissionsDocument = gql`
    query ServiceAccountPermissions($id: UUID!) {
  serviceAccount(id: $id) {
    name
    serviceAccountPermissionAssignments {
      nodes {
        id
        permissionId
      }
      totalCount
    }
  }
}
    `;

/**
 * __useServiceAccountPermissionsQuery__
 *
 * To run a query within a React component, call `useServiceAccountPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAccountPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAccountPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceAccountPermissionsQuery(baseOptions: Apollo.QueryHookOptions<ServiceAccountPermissionsQuery, ServiceAccountPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceAccountPermissionsQuery, ServiceAccountPermissionsQueryVariables>(ServiceAccountPermissionsDocument, options);
      }
export function useServiceAccountPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceAccountPermissionsQuery, ServiceAccountPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceAccountPermissionsQuery, ServiceAccountPermissionsQueryVariables>(ServiceAccountPermissionsDocument, options);
        }
export type ServiceAccountPermissionsQueryHookResult = ReturnType<typeof useServiceAccountPermissionsQuery>;
export type ServiceAccountPermissionsLazyQueryHookResult = ReturnType<typeof useServiceAccountPermissionsLazyQuery>;
export type ServiceAccountPermissionsQueryResult = Apollo.QueryResult<ServiceAccountPermissionsQuery, ServiceAccountPermissionsQueryVariables>;
export const GenerateServiceAccountSecretDocument = gql`
    mutation GenerateServiceAccountSecret($input: GenerateServiceAccountSecretInput!) {
  generateServiceAccountSecret(input: $input) {
    clientSecret
    serviceAccount {
      tenantId
      environmentId
      clientId
      name
      updatedAt
      updatedBy
    }
  }
}
    `;
export type GenerateServiceAccountSecretMutationFn = Apollo.MutationFunction<GenerateServiceAccountSecretMutation, GenerateServiceAccountSecretMutationVariables>;

/**
 * __useGenerateServiceAccountSecretMutation__
 *
 * To run a mutation, you first call `useGenerateServiceAccountSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateServiceAccountSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateServiceAccountSecretMutation, { data, loading, error }] = useGenerateServiceAccountSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateServiceAccountSecretMutation(baseOptions?: Apollo.MutationHookOptions<GenerateServiceAccountSecretMutation, GenerateServiceAccountSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateServiceAccountSecretMutation, GenerateServiceAccountSecretMutationVariables>(GenerateServiceAccountSecretDocument, options);
      }
export type GenerateServiceAccountSecretMutationHookResult = ReturnType<typeof useGenerateServiceAccountSecretMutation>;
export type GenerateServiceAccountSecretMutationResult = Apollo.MutationResult<GenerateServiceAccountSecretMutation>;
export type GenerateServiceAccountSecretMutationOptions = Apollo.BaseMutationOptions<GenerateServiceAccountSecretMutation, GenerateServiceAccountSecretMutationVariables>;
export const ServiceAccountDocument = gql`
    query ServiceAccount($id: UUID!) {
  serviceAccount(id: $id) {
    id
    name
    clientId
    isSecretGenerated
    isProtected
    tenantId
    environmentId
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useServiceAccountQuery__
 *
 * To run a query within a React component, call `useServiceAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceAccountQuery(baseOptions: Apollo.QueryHookOptions<ServiceAccountQuery, ServiceAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceAccountQuery, ServiceAccountQueryVariables>(ServiceAccountDocument, options);
      }
export function useServiceAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceAccountQuery, ServiceAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceAccountQuery, ServiceAccountQueryVariables>(ServiceAccountDocument, options);
        }
export type ServiceAccountQueryHookResult = ReturnType<typeof useServiceAccountQuery>;
export type ServiceAccountLazyQueryHookResult = ReturnType<typeof useServiceAccountLazyQuery>;
export type ServiceAccountQueryResult = Apollo.QueryResult<ServiceAccountQuery, ServiceAccountQueryVariables>;
export const UpdateServiceAccountDocument = gql`
    mutation UpdateServiceAccount($input: UpdateServiceAccountInput!) {
  updateServiceAccount(input: $input) {
    clientMutationId
    serviceAccount {
      name
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateServiceAccountMutationFn = Apollo.MutationFunction<UpdateServiceAccountMutation, UpdateServiceAccountMutationVariables>;

/**
 * __useUpdateServiceAccountMutation__
 *
 * To run a mutation, you first call `useUpdateServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceAccountMutation, { data, loading, error }] = useUpdateServiceAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceAccountMutation, UpdateServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceAccountMutation, UpdateServiceAccountMutationVariables>(UpdateServiceAccountDocument, options);
      }
export type UpdateServiceAccountMutationHookResult = ReturnType<typeof useUpdateServiceAccountMutation>;
export type UpdateServiceAccountMutationResult = Apollo.MutationResult<UpdateServiceAccountMutation>;
export type UpdateServiceAccountMutationOptions = Apollo.BaseMutationOptions<UpdateServiceAccountMutation, UpdateServiceAccountMutationVariables>;
export const DeleteServiceAccountDocument = gql`
    mutation DeleteServiceAccount($input: DeleteServiceAccountInput!) {
  deleteServiceAccount(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteServiceAccountMutationFn = Apollo.MutationFunction<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>;

/**
 * __useDeleteServiceAccountMutation__
 *
 * To run a mutation, you first call `useDeleteServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceAccountMutation, { data, loading, error }] = useDeleteServiceAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteServiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>(DeleteServiceAccountDocument, options);
      }
export type DeleteServiceAccountMutationHookResult = ReturnType<typeof useDeleteServiceAccountMutation>;
export type DeleteServiceAccountMutationResult = Apollo.MutationResult<DeleteServiceAccountMutation>;
export type DeleteServiceAccountMutationOptions = Apollo.BaseMutationOptions<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>;
export const SetServiceAccountProtectionDocument = gql`
    mutation SetServiceAccountProtection($input: SetServiceAccountProtectionInput!) {
  setServiceAccountProtection(input: $input) {
    id
    isProtected
  }
}
    `;
export type SetServiceAccountProtectionMutationFn = Apollo.MutationFunction<SetServiceAccountProtectionMutation, SetServiceAccountProtectionMutationVariables>;

/**
 * __useSetServiceAccountProtectionMutation__
 *
 * To run a mutation, you first call `useSetServiceAccountProtectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetServiceAccountProtectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setServiceAccountProtectionMutation, { data, loading, error }] = useSetServiceAccountProtectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetServiceAccountProtectionMutation(baseOptions?: Apollo.MutationHookOptions<SetServiceAccountProtectionMutation, SetServiceAccountProtectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetServiceAccountProtectionMutation, SetServiceAccountProtectionMutationVariables>(SetServiceAccountProtectionDocument, options);
      }
export type SetServiceAccountProtectionMutationHookResult = ReturnType<typeof useSetServiceAccountProtectionMutation>;
export type SetServiceAccountProtectionMutationResult = Apollo.MutationResult<SetServiceAccountProtectionMutation>;
export type SetServiceAccountProtectionMutationOptions = Apollo.BaseMutationOptions<SetServiceAccountProtectionMutation, SetServiceAccountProtectionMutationVariables>;
export const CreateServiceAccountDocument = gql`
    mutation CreateServiceAccount($input: CreateServiceAccountInput!) {
  createServiceAccount(input: $input) {
    serviceAccount {
      id
      name
    }
  }
}
    `;
export type CreateServiceAccountMutationFn = Apollo.MutationFunction<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;

/**
 * __useCreateServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountMutation, { data, loading, error }] = useCreateServiceAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>(CreateServiceAccountDocument, options);
      }
export type CreateServiceAccountMutationHookResult = ReturnType<typeof useCreateServiceAccountMutation>;
export type CreateServiceAccountMutationResult = Apollo.MutationResult<CreateServiceAccountMutation>;
export type CreateServiceAccountMutationOptions = Apollo.BaseMutationOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;
export const IdServiceConfigDataDocument = gql`
    query IdServiceConfigData($environmentId: UUID!) {
  idServiceConfigurationByEnvironmentId(environmentId: $environmentId) {
    id
    managementSuperAdmins
    allowedOrigins
    accessTokenLifetime
    cookieLifetime
    serviceAccountTokenLifetime
    workflowsEnabled
    tenantId
    environmentId
    createdAt
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useIdServiceConfigDataQuery__
 *
 * To run a query within a React component, call `useIdServiceConfigDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdServiceConfigDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdServiceConfigDataQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useIdServiceConfigDataQuery(baseOptions: Apollo.QueryHookOptions<IdServiceConfigDataQuery, IdServiceConfigDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdServiceConfigDataQuery, IdServiceConfigDataQueryVariables>(IdServiceConfigDataDocument, options);
      }
export function useIdServiceConfigDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdServiceConfigDataQuery, IdServiceConfigDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdServiceConfigDataQuery, IdServiceConfigDataQueryVariables>(IdServiceConfigDataDocument, options);
        }
export type IdServiceConfigDataQueryHookResult = ReturnType<typeof useIdServiceConfigDataQuery>;
export type IdServiceConfigDataLazyQueryHookResult = ReturnType<typeof useIdServiceConfigDataLazyQuery>;
export type IdServiceConfigDataQueryResult = Apollo.QueryResult<IdServiceConfigDataQuery, IdServiceConfigDataQueryVariables>;
export const TokenSigningKeyDocument = gql`
    query TokenSigningKey($environmentId: UUID!) {
  tokenSigningKey(environmentId: $environmentId) {
    kid
    nextRotationAt
  }
}
    `;

/**
 * __useTokenSigningKeyQuery__
 *
 * To run a query within a React component, call `useTokenSigningKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTokenSigningKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTokenSigningKeyQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useTokenSigningKeyQuery(baseOptions: Apollo.QueryHookOptions<TokenSigningKeyQuery, TokenSigningKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TokenSigningKeyQuery, TokenSigningKeyQueryVariables>(TokenSigningKeyDocument, options);
      }
export function useTokenSigningKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TokenSigningKeyQuery, TokenSigningKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TokenSigningKeyQuery, TokenSigningKeyQueryVariables>(TokenSigningKeyDocument, options);
        }
export type TokenSigningKeyQueryHookResult = ReturnType<typeof useTokenSigningKeyQuery>;
export type TokenSigningKeyLazyQueryHookResult = ReturnType<typeof useTokenSigningKeyLazyQuery>;
export type TokenSigningKeyQueryResult = Apollo.QueryResult<TokenSigningKeyQuery, TokenSigningKeyQueryVariables>;
export const UpdateIdServiceConfigDocument = gql`
    mutation UpdateIdServiceConfig($input: UpdateIdServiceConfigurationByEnvironmentIdInput!) {
  updateIdServiceConfigurationByEnvironmentId(input: $input) {
    idServiceConfiguration {
      managementSuperAdmins
      allowedOrigins
      accessTokenLifetime
      cookieLifetime
      serviceAccountTokenLifetime
      workflowsEnabled
    }
  }
}
    `;
export type UpdateIdServiceConfigMutationFn = Apollo.MutationFunction<UpdateIdServiceConfigMutation, UpdateIdServiceConfigMutationVariables>;

/**
 * __useUpdateIdServiceConfigMutation__
 *
 * To run a mutation, you first call `useUpdateIdServiceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdServiceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdServiceConfigMutation, { data, loading, error }] = useUpdateIdServiceConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdServiceConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdServiceConfigMutation, UpdateIdServiceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdServiceConfigMutation, UpdateIdServiceConfigMutationVariables>(UpdateIdServiceConfigDocument, options);
      }
export type UpdateIdServiceConfigMutationHookResult = ReturnType<typeof useUpdateIdServiceConfigMutation>;
export type UpdateIdServiceConfigMutationResult = Apollo.MutationResult<UpdateIdServiceConfigMutation>;
export type UpdateIdServiceConfigMutationOptions = Apollo.BaseMutationOptions<UpdateIdServiceConfigMutation, UpdateIdServiceConfigMutationVariables>;
export const RevokeAndRotateSigningKeyDocument = gql`
    mutation RevokeAndRotateSigningKey($envId: UUID!) {
  revokeAndRotateSigningKey(environmentId: $envId) {
    tokenSigningKey {
      kid
      nextRotationAt
    }
  }
}
    `;
export type RevokeAndRotateSigningKeyMutationFn = Apollo.MutationFunction<RevokeAndRotateSigningKeyMutation, RevokeAndRotateSigningKeyMutationVariables>;

/**
 * __useRevokeAndRotateSigningKeyMutation__
 *
 * To run a mutation, you first call `useRevokeAndRotateSigningKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAndRotateSigningKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAndRotateSigningKeyMutation, { data, loading, error }] = useRevokeAndRotateSigningKeyMutation({
 *   variables: {
 *      envId: // value for 'envId'
 *   },
 * });
 */
export function useRevokeAndRotateSigningKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeAndRotateSigningKeyMutation, RevokeAndRotateSigningKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeAndRotateSigningKeyMutation, RevokeAndRotateSigningKeyMutationVariables>(RevokeAndRotateSigningKeyDocument, options);
      }
export type RevokeAndRotateSigningKeyMutationHookResult = ReturnType<typeof useRevokeAndRotateSigningKeyMutation>;
export type RevokeAndRotateSigningKeyMutationResult = Apollo.MutationResult<RevokeAndRotateSigningKeyMutation>;
export type RevokeAndRotateSigningKeyMutationOptions = Apollo.BaseMutationOptions<RevokeAndRotateSigningKeyMutation, RevokeAndRotateSigningKeyMutationVariables>;
export const IdpConfigurationsCountDocument = gql`
    query IdpConfigurationsCount($condition: IdpConfigurationCondition) {
  idpConfigurations(condition: $condition) {
    totalCount
    nodes {
      enabled
    }
  }
}
    `;

/**
 * __useIdpConfigurationsCountQuery__
 *
 * To run a query within a React component, call `useIdpConfigurationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpConfigurationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpConfigurationsCountQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *   },
 * });
 */
export function useIdpConfigurationsCountQuery(baseOptions?: Apollo.QueryHookOptions<IdpConfigurationsCountQuery, IdpConfigurationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpConfigurationsCountQuery, IdpConfigurationsCountQueryVariables>(IdpConfigurationsCountDocument, options);
      }
export function useIdpConfigurationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpConfigurationsCountQuery, IdpConfigurationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpConfigurationsCountQuery, IdpConfigurationsCountQueryVariables>(IdpConfigurationsCountDocument, options);
        }
export type IdpConfigurationsCountQueryHookResult = ReturnType<typeof useIdpConfigurationsCountQuery>;
export type IdpConfigurationsCountLazyQueryHookResult = ReturnType<typeof useIdpConfigurationsCountLazyQuery>;
export type IdpConfigurationsCountQueryResult = Apollo.QueryResult<IdpConfigurationsCountQuery, IdpConfigurationsCountQueryVariables>;
export const IdpConfigDataDocument = gql`
    query IdpConfigData($condition: IdpConfigurationCondition) {
  idpConfigurations: idpConfigurations(condition: $condition) {
    nodes {
      id
      idpId
      enabled
      displayName
      useCustomBranding
      sortOrder
      idpImageUrl
      status
      environmentId
    }
  }
  scopes: idpScopes {
    nodes {
      idpId
      scopeName
      required
    }
  }
}
    `;

/**
 * __useIdpConfigDataQuery__
 *
 * To run a query within a React component, call `useIdpConfigDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpConfigDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpConfigDataQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *   },
 * });
 */
export function useIdpConfigDataQuery(baseOptions?: Apollo.QueryHookOptions<IdpConfigDataQuery, IdpConfigDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpConfigDataQuery, IdpConfigDataQueryVariables>(IdpConfigDataDocument, options);
      }
export function useIdpConfigDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpConfigDataQuery, IdpConfigDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpConfigDataQuery, IdpConfigDataQueryVariables>(IdpConfigDataDocument, options);
        }
export type IdpConfigDataQueryHookResult = ReturnType<typeof useIdpConfigDataQuery>;
export type IdpConfigDataLazyQueryHookResult = ReturnType<typeof useIdpConfigDataLazyQuery>;
export type IdpConfigDataQueryResult = Apollo.QueryResult<IdpConfigDataQuery, IdpConfigDataQueryVariables>;
export const CreateIdpConfigurationDocument = gql`
    mutation CreateIdpConfiguration($input: CreateIdpConfigurationInput!) {
  createIdpConfiguration(input: $input) {
    clientMutationId
  }
}
    `;
export type CreateIdpConfigurationMutationFn = Apollo.MutationFunction<CreateIdpConfigurationMutation, CreateIdpConfigurationMutationVariables>;

/**
 * __useCreateIdpConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateIdpConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdpConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdpConfigurationMutation, { data, loading, error }] = useCreateIdpConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdpConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdpConfigurationMutation, CreateIdpConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdpConfigurationMutation, CreateIdpConfigurationMutationVariables>(CreateIdpConfigurationDocument, options);
      }
export type CreateIdpConfigurationMutationHookResult = ReturnType<typeof useCreateIdpConfigurationMutation>;
export type CreateIdpConfigurationMutationResult = Apollo.MutationResult<CreateIdpConfigurationMutation>;
export type CreateIdpConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateIdpConfigurationMutation, CreateIdpConfigurationMutationVariables>;
export const EnvironmentsDocument = gql`
    query Environments {
  environments {
    totalCount
  }
}
    `;

/**
 * __useEnvironmentsQuery__
 *
 * To run a query within a React component, call `useEnvironmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnvironmentsQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentsQuery, EnvironmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(EnvironmentsDocument, options);
      }
export function useEnvironmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentsQuery, EnvironmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(EnvironmentsDocument, options);
        }
export type EnvironmentsQueryHookResult = ReturnType<typeof useEnvironmentsQuery>;
export type EnvironmentsLazyQueryHookResult = ReturnType<typeof useEnvironmentsLazyQuery>;
export type EnvironmentsQueryResult = Apollo.QueryResult<EnvironmentsQuery, EnvironmentsQueryVariables>;
export const TenantAdminsDocument = gql`
    query TenantAdmins {
  tenantAdmins {
    totalCount
  }
}
    `;

/**
 * __useTenantAdminsQuery__
 *
 * To run a query within a React component, call `useTenantAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantAdminsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantAdminsQuery(baseOptions?: Apollo.QueryHookOptions<TenantAdminsQuery, TenantAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantAdminsQuery, TenantAdminsQueryVariables>(TenantAdminsDocument, options);
      }
export function useTenantAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantAdminsQuery, TenantAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantAdminsQuery, TenantAdminsQueryVariables>(TenantAdminsDocument, options);
        }
export type TenantAdminsQueryHookResult = ReturnType<typeof useTenantAdminsQuery>;
export type TenantAdminsLazyQueryHookResult = ReturnType<typeof useTenantAdminsLazyQuery>;
export type TenantAdminsQueryResult = Apollo.QueryResult<TenantAdminsQuery, TenantAdminsQueryVariables>;
export const IdpConfigurationsDocument = gql`
    query IdpConfigurations($idpConfigurationCondition: IdpConfigurationCondition, $idpScopeFilter: IdpScopeFilter) {
  configurations: idpConfigurations(condition: $idpConfigurationCondition) {
    nodes {
      id
      idpId
      useBuiltInIdp
      discoveryDocumentUrl
      clientId
      clientSecretIsSet
      scopes
      enabled
      useCustomBranding
      displayName
      idpImageUrl
      sortOrder
      logoutFromIdp
      tenantId
      environmentId
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
  scopes: idpScopes(filter: $idpScopeFilter) {
    nodes {
      scopeName
      required
    }
  }
}
    `;

/**
 * __useIdpConfigurationsQuery__
 *
 * To run a query within a React component, call `useIdpConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdpConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdpConfigurationsQuery({
 *   variables: {
 *      idpConfigurationCondition: // value for 'idpConfigurationCondition'
 *      idpScopeFilter: // value for 'idpScopeFilter'
 *   },
 * });
 */
export function useIdpConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<IdpConfigurationsQuery, IdpConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdpConfigurationsQuery, IdpConfigurationsQueryVariables>(IdpConfigurationsDocument, options);
      }
export function useIdpConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdpConfigurationsQuery, IdpConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdpConfigurationsQuery, IdpConfigurationsQueryVariables>(IdpConfigurationsDocument, options);
        }
export type IdpConfigurationsQueryHookResult = ReturnType<typeof useIdpConfigurationsQuery>;
export type IdpConfigurationsLazyQueryHookResult = ReturnType<typeof useIdpConfigurationsLazyQuery>;
export type IdpConfigurationsQueryResult = Apollo.QueryResult<IdpConfigurationsQuery, IdpConfigurationsQueryVariables>;
export const UpdateIdpConfigurationDocument = gql`
    mutation updateIdpConfiguration($input: UpdateIdpConfigurationInput!) {
  updateIdpConfiguration(input: $input) {
    idpConfiguration {
      useBuiltInIdp
      discoveryDocumentUrl
      clientId
      clientSecretIsSet
      scopes
      useCustomBranding
      displayName
      logoutFromIdp
      enabled
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateIdpConfigurationMutationFn = Apollo.MutationFunction<UpdateIdpConfigurationMutation, UpdateIdpConfigurationMutationVariables>;

/**
 * __useUpdateIdpConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateIdpConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdpConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdpConfigurationMutation, { data, loading, error }] = useUpdateIdpConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdpConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdpConfigurationMutation, UpdateIdpConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdpConfigurationMutation, UpdateIdpConfigurationMutationVariables>(UpdateIdpConfigurationDocument, options);
      }
export type UpdateIdpConfigurationMutationHookResult = ReturnType<typeof useUpdateIdpConfigurationMutation>;
export type UpdateIdpConfigurationMutationResult = Apollo.MutationResult<UpdateIdpConfigurationMutation>;
export type UpdateIdpConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateIdpConfigurationMutation, UpdateIdpConfigurationMutationVariables>;
export const DeleteIdpConfigurationDocument = gql`
    mutation DeleteIdpConfiguration($input: DeleteIdpConfigurationInput!) {
  deleteIdpConfiguration(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteIdpConfigurationMutationFn = Apollo.MutationFunction<DeleteIdpConfigurationMutation, DeleteIdpConfigurationMutationVariables>;

/**
 * __useDeleteIdpConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteIdpConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdpConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdpConfigurationMutation, { data, loading, error }] = useDeleteIdpConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIdpConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdpConfigurationMutation, DeleteIdpConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdpConfigurationMutation, DeleteIdpConfigurationMutationVariables>(DeleteIdpConfigurationDocument, options);
      }
export type DeleteIdpConfigurationMutationHookResult = ReturnType<typeof useDeleteIdpConfigurationMutation>;
export type DeleteIdpConfigurationMutationResult = Apollo.MutationResult<DeleteIdpConfigurationMutation>;
export type DeleteIdpConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteIdpConfigurationMutation, DeleteIdpConfigurationMutationVariables>;
export const EnvironmentsWithDataDocument = gql`
    query EnvironmentsWithData($filter: EnvironmentFilter, $orderBy: [EnvironmentsOrderBy!], $after: Cursor) {
  filtered: environments(
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      name
      enabled
      isDevelopment
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
  nonFiltered: environments {
    totalCount
  }
}
    `;

/**
 * __useEnvironmentsWithDataQuery__
 *
 * To run a query within a React component, call `useEnvironmentsWithDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentsWithDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentsWithDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEnvironmentsWithDataQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentsWithDataQuery, EnvironmentsWithDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentsWithDataQuery, EnvironmentsWithDataQueryVariables>(EnvironmentsWithDataDocument, options);
      }
export function useEnvironmentsWithDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentsWithDataQuery, EnvironmentsWithDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentsWithDataQuery, EnvironmentsWithDataQueryVariables>(EnvironmentsWithDataDocument, options);
        }
export type EnvironmentsWithDataQueryHookResult = ReturnType<typeof useEnvironmentsWithDataQuery>;
export type EnvironmentsWithDataLazyQueryHookResult = ReturnType<typeof useEnvironmentsWithDataLazyQuery>;
export type EnvironmentsWithDataQueryResult = Apollo.QueryResult<EnvironmentsWithDataQuery, EnvironmentsWithDataQueryVariables>;
export const EnvironmentDocument = gql`
    query Environment($id: UUID!) {
  environment(id: $id) {
    id
    tenantId
    name
    environmentTemplateName
    enabled
    isDevelopment
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useEnvironmentQuery__
 *
 * To run a query within a React component, call `useEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentQuery, EnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentQuery, EnvironmentQueryVariables>(EnvironmentDocument, options);
      }
export function useEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentQuery, EnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentQuery, EnvironmentQueryVariables>(EnvironmentDocument, options);
        }
export type EnvironmentQueryHookResult = ReturnType<typeof useEnvironmentQuery>;
export type EnvironmentLazyQueryHookResult = ReturnType<typeof useEnvironmentLazyQuery>;
export type EnvironmentQueryResult = Apollo.QueryResult<EnvironmentQuery, EnvironmentQueryVariables>;
export const DeleteEnvironmentDocument = gql`
    mutation DeleteEnvironment($input: DeleteEnvironmentInput!) {
  deleteEnvironment(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteEnvironmentMutationFn = Apollo.MutationFunction<DeleteEnvironmentMutation, DeleteEnvironmentMutationVariables>;

/**
 * __useDeleteEnvironmentMutation__
 *
 * To run a mutation, you first call `useDeleteEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnvironmentMutation, { data, loading, error }] = useDeleteEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnvironmentMutation, DeleteEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEnvironmentMutation, DeleteEnvironmentMutationVariables>(DeleteEnvironmentDocument, options);
      }
export type DeleteEnvironmentMutationHookResult = ReturnType<typeof useDeleteEnvironmentMutation>;
export type DeleteEnvironmentMutationResult = Apollo.MutationResult<DeleteEnvironmentMutation>;
export type DeleteEnvironmentMutationOptions = Apollo.BaseMutationOptions<DeleteEnvironmentMutation, DeleteEnvironmentMutationVariables>;
export const ChangeManagedServiceStateDocument = gql`
    mutation ChangeManagedServiceState($input: ChangeServiceStateInput!) {
  changeManagedServiceState(input: $input) {
    successfullySent
  }
}
    `;
export type ChangeManagedServiceStateMutationFn = Apollo.MutationFunction<ChangeManagedServiceStateMutation, ChangeManagedServiceStateMutationVariables>;

/**
 * __useChangeManagedServiceStateMutation__
 *
 * To run a mutation, you first call `useChangeManagedServiceStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeManagedServiceStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeManagedServiceStateMutation, { data, loading, error }] = useChangeManagedServiceStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeManagedServiceStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeManagedServiceStateMutation, ChangeManagedServiceStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeManagedServiceStateMutation, ChangeManagedServiceStateMutationVariables>(ChangeManagedServiceStateDocument, options);
      }
export type ChangeManagedServiceStateMutationHookResult = ReturnType<typeof useChangeManagedServiceStateMutation>;
export type ChangeManagedServiceStateMutationResult = Apollo.MutationResult<ChangeManagedServiceStateMutation>;
export type ChangeManagedServiceStateMutationOptions = Apollo.BaseMutationOptions<ChangeManagedServiceStateMutation, ChangeManagedServiceStateMutationVariables>;
export const CreateEnvironmentDocument = gql`
    mutation CreateEnvironment($input: CreateEnvironmentInput!) {
  createEnvironment(input: $input) {
    environment {
      id
      tenantId
      name
      environmentTemplateId
      enabled
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
}
    `;
export type CreateEnvironmentMutationFn = Apollo.MutationFunction<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>;

/**
 * __useCreateEnvironmentMutation__
 *
 * To run a mutation, you first call `useCreateEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnvironmentMutation, { data, loading, error }] = useCreateEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>(CreateEnvironmentDocument, options);
      }
export type CreateEnvironmentMutationHookResult = ReturnType<typeof useCreateEnvironmentMutation>;
export type CreateEnvironmentMutationResult = Apollo.MutationResult<CreateEnvironmentMutation>;
export type CreateEnvironmentMutationOptions = Apollo.BaseMutationOptions<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>;
export const EnvironmentTemplateDataDocument = gql`
    query EnvironmentTemplateData {
  environmentTemplates(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useEnvironmentTemplateDataQuery__
 *
 * To run a query within a React component, call `useEnvironmentTemplateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentTemplateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentTemplateDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnvironmentTemplateDataQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentTemplateDataQuery, EnvironmentTemplateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentTemplateDataQuery, EnvironmentTemplateDataQueryVariables>(EnvironmentTemplateDataDocument, options);
      }
export function useEnvironmentTemplateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentTemplateDataQuery, EnvironmentTemplateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentTemplateDataQuery, EnvironmentTemplateDataQueryVariables>(EnvironmentTemplateDataDocument, options);
        }
export type EnvironmentTemplateDataQueryHookResult = ReturnType<typeof useEnvironmentTemplateDataQuery>;
export type EnvironmentTemplateDataLazyQueryHookResult = ReturnType<typeof useEnvironmentTemplateDataLazyQuery>;
export type EnvironmentTemplateDataQueryResult = Apollo.QueryResult<EnvironmentTemplateDataQuery, EnvironmentTemplateDataQueryVariables>;
export const EnvironmentManagedServicesDocument = gql`
    query EnvironmentManagedServices($condition: EnvironmentManagedServiceCondition!, $filter: EnvironmentManagedServiceFilter!) {
  environmentManagedServices(condition: $condition, filter: $filter) {
    nodes {
      managedServiceId
      managedServiceName
      state
    }
  }
}
    `;

/**
 * __useEnvironmentManagedServicesQuery__
 *
 * To run a query within a React component, call `useEnvironmentManagedServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentManagedServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentManagedServicesQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEnvironmentManagedServicesQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentManagedServicesQuery, EnvironmentManagedServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentManagedServicesQuery, EnvironmentManagedServicesQueryVariables>(EnvironmentManagedServicesDocument, options);
      }
export function useEnvironmentManagedServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentManagedServicesQuery, EnvironmentManagedServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentManagedServicesQuery, EnvironmentManagedServicesQueryVariables>(EnvironmentManagedServicesDocument, options);
        }
export type EnvironmentManagedServicesQueryHookResult = ReturnType<typeof useEnvironmentManagedServicesQuery>;
export type EnvironmentManagedServicesLazyQueryHookResult = ReturnType<typeof useEnvironmentManagedServicesLazyQuery>;
export type EnvironmentManagedServicesQueryResult = Apollo.QueryResult<EnvironmentManagedServicesQuery, EnvironmentManagedServicesQueryVariables>;
export const EnvironmentConnectionDocument = gql`
    query EnvironmentConnection($environmentId: UUID!, $serviceAccountCondition: ServiceAccountCondition!) {
  environment(id: $environmentId) {
    isDevelopment
  }
  serviceAccounts(condition: $serviceAccountCondition) {
    nodes {
      id
      clientId
    }
  }
}
    `;

/**
 * __useEnvironmentConnectionQuery__
 *
 * To run a query within a React component, call `useEnvironmentConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentConnectionQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      serviceAccountCondition: // value for 'serviceAccountCondition'
 *   },
 * });
 */
export function useEnvironmentConnectionQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentConnectionQuery, EnvironmentConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentConnectionQuery, EnvironmentConnectionQueryVariables>(EnvironmentConnectionDocument, options);
      }
export function useEnvironmentConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentConnectionQuery, EnvironmentConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentConnectionQuery, EnvironmentConnectionQueryVariables>(EnvironmentConnectionDocument, options);
        }
export type EnvironmentConnectionQueryHookResult = ReturnType<typeof useEnvironmentConnectionQuery>;
export type EnvironmentConnectionLazyQueryHookResult = ReturnType<typeof useEnvironmentConnectionLazyQuery>;
export type EnvironmentConnectionQueryResult = Apollo.QueryResult<EnvironmentConnectionQuery, EnvironmentConnectionQueryVariables>;
export const EmailWhitelistPatternsDocument = gql`
    query EmailWhitelistPatterns($condition: EmailWhitelistPatternCondition, $filter: EmailWhitelistPatternFilter, $orderBy: [EmailWhitelistPatternsOrderBy!], $after: Cursor) {
  filtered: emailWhitelistPatterns(
    condition: $condition
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      emailPattern
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
  nonFiltered: emailWhitelistPatterns(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useEmailWhitelistPatternsQuery__
 *
 * To run a query within a React component, call `useEmailWhitelistPatternsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailWhitelistPatternsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailWhitelistPatternsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEmailWhitelistPatternsQuery(baseOptions?: Apollo.QueryHookOptions<EmailWhitelistPatternsQuery, EmailWhitelistPatternsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailWhitelistPatternsQuery, EmailWhitelistPatternsQueryVariables>(EmailWhitelistPatternsDocument, options);
      }
export function useEmailWhitelistPatternsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailWhitelistPatternsQuery, EmailWhitelistPatternsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailWhitelistPatternsQuery, EmailWhitelistPatternsQueryVariables>(EmailWhitelistPatternsDocument, options);
        }
export type EmailWhitelistPatternsQueryHookResult = ReturnType<typeof useEmailWhitelistPatternsQuery>;
export type EmailWhitelistPatternsLazyQueryHookResult = ReturnType<typeof useEmailWhitelistPatternsLazyQuery>;
export type EmailWhitelistPatternsQueryResult = Apollo.QueryResult<EmailWhitelistPatternsQuery, EmailWhitelistPatternsQueryVariables>;
export const EmailWhitelistPatternDocument = gql`
    query emailWhitelistPattern($id: UUID!) {
  emailWhitelistPattern(id: $id) {
    id
    emailPattern
    tenantId
    environmentId
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
  emailWhitelistPatternRoles(condition: {emailWhitelistPatternId: $id}) {
    nodes {
      id
      userRoleId
      userRoleName
      userRoleDescription
    }
  }
}
    `;

/**
 * __useEmailWhitelistPatternQuery__
 *
 * To run a query within a React component, call `useEmailWhitelistPatternQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailWhitelistPatternQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailWhitelistPatternQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailWhitelistPatternQuery(baseOptions: Apollo.QueryHookOptions<EmailWhitelistPatternQuery, EmailWhitelistPatternQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailWhitelistPatternQuery, EmailWhitelistPatternQueryVariables>(EmailWhitelistPatternDocument, options);
      }
export function useEmailWhitelistPatternLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailWhitelistPatternQuery, EmailWhitelistPatternQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailWhitelistPatternQuery, EmailWhitelistPatternQueryVariables>(EmailWhitelistPatternDocument, options);
        }
export type EmailWhitelistPatternQueryHookResult = ReturnType<typeof useEmailWhitelistPatternQuery>;
export type EmailWhitelistPatternLazyQueryHookResult = ReturnType<typeof useEmailWhitelistPatternLazyQuery>;
export type EmailWhitelistPatternQueryResult = Apollo.QueryResult<EmailWhitelistPatternQuery, EmailWhitelistPatternQueryVariables>;
export const UpdateEmailWhitelistPatternDocument = gql`
    mutation UpdateEmailWhitelistPattern($input: UpdateEmailWhitelistPatternInput!) {
  updateEmailWhitelistPattern(input: $input) {
    clientMutationId
    emailWhitelistPattern {
      emailPattern
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateEmailWhitelistPatternMutationFn = Apollo.MutationFunction<UpdateEmailWhitelistPatternMutation, UpdateEmailWhitelistPatternMutationVariables>;

/**
 * __useUpdateEmailWhitelistPatternMutation__
 *
 * To run a mutation, you first call `useUpdateEmailWhitelistPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailWhitelistPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailWhitelistPatternMutation, { data, loading, error }] = useUpdateEmailWhitelistPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailWhitelistPatternMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailWhitelistPatternMutation, UpdateEmailWhitelistPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailWhitelistPatternMutation, UpdateEmailWhitelistPatternMutationVariables>(UpdateEmailWhitelistPatternDocument, options);
      }
export type UpdateEmailWhitelistPatternMutationHookResult = ReturnType<typeof useUpdateEmailWhitelistPatternMutation>;
export type UpdateEmailWhitelistPatternMutationResult = Apollo.MutationResult<UpdateEmailWhitelistPatternMutation>;
export type UpdateEmailWhitelistPatternMutationOptions = Apollo.BaseMutationOptions<UpdateEmailWhitelistPatternMutation, UpdateEmailWhitelistPatternMutationVariables>;
export const DeleteEmailWhitelistPatternDocument = gql`
    mutation DeleteEmailWhitelistPattern($input: DeleteEmailWhitelistPatternInput!) {
  deleteEmailWhitelistPattern(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteEmailWhitelistPatternMutationFn = Apollo.MutationFunction<DeleteEmailWhitelistPatternMutation, DeleteEmailWhitelistPatternMutationVariables>;

/**
 * __useDeleteEmailWhitelistPatternMutation__
 *
 * To run a mutation, you first call `useDeleteEmailWhitelistPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailWhitelistPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailWhitelistPatternMutation, { data, loading, error }] = useDeleteEmailWhitelistPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEmailWhitelistPatternMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailWhitelistPatternMutation, DeleteEmailWhitelistPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailWhitelistPatternMutation, DeleteEmailWhitelistPatternMutationVariables>(DeleteEmailWhitelistPatternDocument, options);
      }
export type DeleteEmailWhitelistPatternMutationHookResult = ReturnType<typeof useDeleteEmailWhitelistPatternMutation>;
export type DeleteEmailWhitelistPatternMutationResult = Apollo.MutationResult<DeleteEmailWhitelistPatternMutation>;
export type DeleteEmailWhitelistPatternMutationOptions = Apollo.BaseMutationOptions<DeleteEmailWhitelistPatternMutation, DeleteEmailWhitelistPatternMutationVariables>;
export const CreateEmailWhitelistPatternDocument = gql`
    mutation CreateEmailWhitelistPattern($input: CreateEmailWhitelistPatternInput!) {
  createEmailWhitelistPattern(input: $input) {
    emailWhitelistPattern {
      id
      emailPattern
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
}
    `;
export type CreateEmailWhitelistPatternMutationFn = Apollo.MutationFunction<CreateEmailWhitelistPatternMutation, CreateEmailWhitelistPatternMutationVariables>;

/**
 * __useCreateEmailWhitelistPatternMutation__
 *
 * To run a mutation, you first call `useCreateEmailWhitelistPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailWhitelistPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailWhitelistPatternMutation, { data, loading, error }] = useCreateEmailWhitelistPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailWhitelistPatternMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailWhitelistPatternMutation, CreateEmailWhitelistPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailWhitelistPatternMutation, CreateEmailWhitelistPatternMutationVariables>(CreateEmailWhitelistPatternDocument, options);
      }
export type CreateEmailWhitelistPatternMutationHookResult = ReturnType<typeof useCreateEmailWhitelistPatternMutation>;
export type CreateEmailWhitelistPatternMutationResult = Apollo.MutationResult<CreateEmailWhitelistPatternMutation>;
export type CreateEmailWhitelistPatternMutationOptions = Apollo.BaseMutationOptions<CreateEmailWhitelistPatternMutation, CreateEmailWhitelistPatternMutationVariables>;